/* eslint-disable */ 
import { URL } from '../../../config'
import { getRequest } from '../../../utils/functions/httpRequest'

export const getScheduleResultsBySeason = function (seasonId) 
{
    const endpoint = `/${seasonId}/scheduleresults`
    const rankingURL = `${URL.ranking}${endpoint}` 
    return getRequest(rankingURL)
} 
 


// WEBPACK FOOTER //
// ./src/components/pages/api/getScheduleResultsBySeason.js